export function Logout(){
    return(<svg viewBox="0 0 24 24"><path d="M3 5c0-1.1.9-2 2-2h8v2H5v14h8v2H5c-1.1 0-2-.9-2-2V5zm14.176 6L14.64 8.464l1.414-1.414l4.95 4.95l-4.95 4.95l-1.414-1.414L17.176 13H10.59v-2h6.586z" fill="currentColor" fillRule="evenodd"></path></svg>)
}